import {isNil} from 'ramda';

import i18n from '@dms/i18n';

/**
 * Formats a warranty duration (in months) for display, e.g. `24 months`.
 * Returns null when the duration is not set so callers can omit it.
 */
export const formatWarrantyDuration = (duration: number | null): string | null => {
  if (isNil(duration)) {
    return null;
  }

  return `${duration} ${i18n.t('general.labels.months')}`;
};
